import { DateTime } from 'luxon';
import { belfioreCodeRegex, capRegex, regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const CommonMunicipalityCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Comuni',
    path: '/sistema/geografiche/comune',
  },
];

export const validationSchemaForeign = yup.object().shape({
  // region: yup.string().required('Il campo regione è obbligatorio'),
  // code: yup.string().required('Il campo codice comune è obbligatorio'),
  name: yup.string().required('Il campo nome comune è obbligatorio'),
  // province: yup.string().required('Il campo nome provincia è obbligatorio'),
  foreignState: yup.string().required('Il campo stato estero è obbligatorio'),
  // capital: yup.string().required('Il campo nome provincia è obbligatorio'),
  // court: yup.string().required('Il campo tribunale è obbligatorio'),
  // cap: yup.string().required('Il campo nome provincia è obbligatorio'),
  fiscalCode: yup.string().required('Il campo codice fiscale è obbligatorio'),
  // institutionDate: yup.string().required('Il campo data istituzione è obbligatorio'),
  // flag: yup.boolean().required('Il campo nome provincia è obbligatorio'),
  // oldCode: yup.string().required('Il campo nome provincia è obbligatorio'),
  // istatCode: yup.string().required('Il campo nome provincia è obbligatorio'),
  territory: yup.string().notRequired().nullable(),
  site: yup.string().notRequired().nullable(),
});

export const validationSchemaItalian = yup.object().shape({
  code: yup
    .string()
    .matches(regexOnlyNumber, 'Il campo codice comune deve essere un numero')
    .required('Il campo codice comune è obbligatorio'),
  name: yup
    .string()
    .required('Il campo nome comune è obbligatorio')
    .max(40, 'Il campo nome non può superare i 40 caratteri'),
  province: yup.string().when('isForeign', {
    is: true,
    then: yup.string(),
    otherwise: yup.string().required('Il campo provincia è obbligatorio'),
  }),
  region: yup.string().when('isForeign', {
    is: true,
    then: yup.string(),
    otherwise: yup.string().required('Il campo regione è obbligatorio'),
  }),
  capital: yup.string().notRequired().nullable(),
  court: yup
    .string()
    .matches(regexOnlyNumber, 'Il campo tribunale deve essere un numero')
    .required('Il campo tribunale è obbligatorio'),
  cap: yup
    .string()
    .matches(capRegex, 'Il C.A.P. deve contenere 5 numeri')
    .required('Il campo C.A.P. è obbligatorio'),
  fiscalCode: yup
    .string()
    .matches(belfioreCodeRegex, 'Il campo non è un codice fiscale valido')
    .required('Il campo codice fiscale è obbligatorio'),
  institutionDate: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .required('Il campo data istituzione è obbligatorio'),
  // flag: yup.boolean().required('Il campo nome provincia è obbligatorio'),
  // oldCode: yup.string().required('Il campo nome provincia è obbligatorio'),
  // istatCode: yup.string().required('Il campo nome provincia è obbligatorio'),
});

export const validationSchemaEnded = yup.object().shape({
  isForeign: yup.boolean().required(),
  region: yup.string().when('isForeign', {
    is: true,
    then: yup.string(),
    otherwise: yup.string().required('Il campo regione è obbligatorio'),
  }),
  oldCode: yup
    .string()
    .required('Il campo è obbligatorio')
    .matches(regexOnlyNumber, 'Il campo deve essere numerico'),
  istatCode: yup
    .string()
    .matches(regexOnlyNumber, 'Il campo codice comune deve essere un numero')
    .notRequired()
    .nullable()
    .typeError('Sono ammesse solamente cifre')
    .when('isForeign', {
      is: false,
      then: yup.string().required('Il campo è obbligatorio'),
      otherwise: yup.string().notRequired(),
    }),
  name: yup.string().required('Il campo nome comune è obbligatorio'),
  province: yup.string().when('isForeign', {
    is: true,
    then: yup.string(),
    otherwise: yup.string().required('Il campo provincia è obbligatorio'),
  }),
  capital: yup.string().notRequired().nullable(),
  court: yup.string().when('isForeign', {
    is: true,
    then: yup.string().matches(regexOnlyNumber, 'Il campo tribunale deve essere un numero'),
    otherwise: yup
      .string()
      .matches(regexOnlyNumber, 'Il campo tribunale deve essere un numero')
      .required('Il campo tribunale è obbligatorio'),
  }),
  cap: yup.string().when('isForeign', {
    is: true,
    then: yup.string().nullable().matches(capRegex, 'Il C.A.P. deve contenere 5 numeri'),
    otherwise: yup
      .string()
      .nullable()
      .matches(capRegex, 'Il C.A.P. deve contenere 5 numeri')
      .required('Campo richiesto'),
  }),
  fiscalCode: yup.string().required('Il campo codice fiscale è obbligatorio'),
  institutionDate: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .required('Il campo data istituzione è obbligatorio'),
  endDate: yup
    .date()
    .required('Il campo data cessazione è obbligatorio')
    .nullable()
    .typeError('Data non valida')
    .max(
      DateTime.now().plus({ days: 1 }),
      'La data cessazione non può essere successiva alla data odierna'
    )
    .min(
      yup.ref('institutionDate'),
      'La data cessazione non può essere minore della data di istituzione'
    ),
  territory: yup.string().notRequired().nullable(),
  site: yup.string().notRequired().nullable(),
  foreignState: yup.string().when('isForeign', {
    is: false,
    then: yup.string(),
    otherwise: yup.string().required('Il campo stato estero è obbligatorio'),
  }),
});
